import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./success-md.svg?react";

export const SuccessMdIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
